import { AccommodationRoomTileActionsState } from './AccommodationRoomTileActions'

interface GetActionsStateParams {
  availableForPurchase?: boolean
  roomFitsCapacity: boolean
  datesAvailable: boolean
  // Multi-room specific params (optional)
  isMultiRoom?: boolean
  checkIn?: string
  isSoldOut?: boolean
  hasExceededCapacity?: boolean
  isAllRoomsAvailable?: boolean
  isAllRoomsHaveAvailabilityData?: boolean
}

/**
 * Determines the appropriate AccommodationRoomTileActionsState based on
 * availability, capacity, and multi-room conditions.
 *
 * Used by both desktop and mobile FlashHotel components to ensure consistent behavior.
 */
export function getAccommodationRoomTileActionsState(
  params: GetActionsStateParams,
): AccommodationRoomTileActionsState | undefined {
  const {
    availableForPurchase,
    roomFitsCapacity,
    datesAvailable,
    isMultiRoom,
    checkIn,
    isSoldOut,
    hasExceededCapacity,
    isAllRoomsAvailable,
    isAllRoomsHaveAvailabilityData,
  } = params

  // Not available for purchase at all
  if (!availableForPurchase) {
    return 'sold-out'
  }

  // Multi-room mode has additional states when dates are selected
  if (isMultiRoom && checkIn) {
    if (isSoldOut) {
      return 'sold-out'
    }
    if (hasExceededCapacity) {
      return 'exceeded-capacity'
    }
    if (isAllRoomsHaveAvailabilityData && !isAllRoomsAvailable) {
      return 'available-for-some-rooms'
    }
  }

  // Single-room / general logic
  if (!roomFitsCapacity && !datesAvailable) {
    return 'sold-out-on-dates-or-exceeded-capacity'
  }
  if (!roomFitsCapacity) {
    return 'exceeded-capacity'
  }
  if (!datesAvailable) {
    return 'sold-out-on-dates'
  }

  return undefined
}
